import p1 from './p1.png';
import p2 from './p2.png';
import p3 from './p3.png';
import p4 from './p4.png';
import p5 from './p5.png';
import p6 from './p6.png';
import p7 from './p7.png';
import p8 from './p8.png';
import rm1 from './rm1.png';
import rm2 from './rm2.png';
import rm3 from './rm3.png';
import rm4 from './rm4.png';
import tt from './twitter.svg';
import gh from './github.svg';
import ln from './linkedin.svg';
import op from './opensea.png';
import oplogo from './opensealogo.png';
import pl from './polygon.png';
import hl from './headerlogo.png';
import nftart from './nftart.gif';
import u1 from './u1.jpeg';
import u2 from './u2.jpg';
import u3 from './u3.jpg';
import u5 from './u5.jpg';
import u4 from './devpunk.png';
import artesanato from './artesanato.png';
import ticket from './ticket.png';
import voucher from './voucher.jpg';



export default {
   p1,
   voucher,
   ticket,
   artesanato,
   u1,
   u2,
   u3,
   u4,
   u5,
   nftart,
   hl,
   p2,
   p3,
   p4,
   p5,
   p6,
   p7,
   p8,
   rm1,
   rm2,
   rm3,
   rm4,
   tt,
   gh,
   ln,
   op,
   oplogo,
   pl,
 };